<template>
    <div class="lime-body">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-separator-1">
                            <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
                            <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
                        </ol>
                    </nav>
                    <div class="page-title">
               <h3>Invoices </h3>
               <div class="search-create">
                <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :on-cancel="onCancel"
                :is-full-page="fullPage"></loading>
                  <div class="search">
                    <input class="form-control mr-sm-2"  v-model="filter" @keydown="$event.stopImmediatePropagation()" type="text" placeholder="Search invoice" aria-label="Search" />
                  </div>
                  <!-- <button class="btn btn-primary" id="userBtn" v-on:click="userBtn()"><i class="material-icons">add</i> Add User</button> -->
               </div>
            </div>

                </div>
            </div>
            
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <datatable :class="tblCls" :columns="columns" :filter="filter" :per-page="10" :data="invoicesList"></datatable>   
                  <datatable-pager v-model="page" class="pagination"></datatable-pager>
                </div>
              </div>
            </div>
        </div>  
    </div>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'UserDashboard',
  components: {
    Loading
  },
  data () {
    return {
      msg: 'Dashboard',
      invoicesList: [],
      isLoading: false,
      fullPage: true,
      tblCls: 'table',
      columns: [
        {label: 'Invoice Number', field: 'id'},
        {label: 'Brand', field: 'brand', headerClass: 'class-in-header second-class'},
        {label: 'CreatedOn', field: 'created'},
        {label: 'Due Date', field: 'due_date'},
        {label: 'Invoice Amount ($)', field: 'invoice_amount'},
        {label: 'Your Amount ($)', field: 'amount'},
        {label: 'Status',
          field: 'status',
          interpolate: true,
          representedAs: function (row) {
            if (row.status === 'open') {
              return ` <span style="color:red">${row.status}</span> `
            } else if (row.status === 'draft') {
              return ` <span style="color:blue">${row.status}</span> `
            } else if (row.status === 'past due') {
              return ` <span style="color:#570702">${row.status}</span> `
            } else {
              return ` <span style="color:green">${row.status}</span> `
            }
          }
        }
      ],
      rows: this.invoicesList,
      filter: '',
      page: 1
    }
  },
  methods: {
    getUserInvoices () {
      var jwttoken = localStorage.getItem('jwt')
      var uid = localStorage.getItem('uid')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserInvoices' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.invoices = response.data.results
          for (var i in this.invoices) {
            var obj = this.invoices[i]
            var amount = Number(obj.amount).toLocaleString()
            this.invoicesList.push({
              id: obj.invoice_number,
              brand: obj.brand_name,
              created: obj.createdOn,
              due_date: obj.due_date,
              invoice_amount: obj.invoice_amount,
              amount: amount,
              status: obj.status
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.getUserInvoices()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserDashboard.vue